import React from 'react';


// import animate on scroll
import Aos from 'aos';
import 'aos/dist/aos.css';

// import components
import Hero from './components/Hero';
import Aboutvideo from './components/Aboutvideo';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import Content from './components/Content';

const Video = () => {
  // animate on scroll initialization
  Aos.init({
    duration: 1800,
    offset: 0,
  });
  return (
    <div className='overflow-hidden'>
      <Hero />
      <Aboutvideo />
      <Content/>
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Video;
